import { Component, Inject, OnInit, Optional } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';
import { MASKS } from 'ng-brazil';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { CRMCanalVenda } from 'src/app/models/crm/crmcanal-venda';
import { CRMEtapaFunil } from 'src/app/models/crm/crmetapa-funil';
import { CRM } from 'src/app/models/crm/crmfunil';
import { CRMOportunidade } from 'src/app/models/crm/crmoportunidade';
import { CRMTag } from 'src/app/models/crm/crmtag';
import { CRMAtributoMascara, PerfilDoUsuario, StatusCadastroEnum } from 'src/app/models/enum';
import { CarregandoService } from 'src/app/services/carregando.service';
import { CrmService } from 'src/app/services/crm/crm.service';
import { CrmatributoService } from 'src/app/services/crm/crmatributo.service';
import { CrmcanalVendaService } from 'src/app/services/crm/crmcanal-venda.service';
import { CrmcontatoService } from 'src/app/services/crm/crmcontato.service';
import { CrmoportunidadeService } from 'src/app/services/crm/crmoportunidade.service';
import { CrmtagService } from 'src/app/services/crm/crmtag.service';
import { GlobalService } from 'src/app/services/global.service';
import { NotificacaoService } from 'src/app/services/notificacao.service';
import { UtilitarioService } from 'src/app/services/utilitario.service';
import swal from 'sweetalert2';
import { IntegradorCrmModalComponent } from '../../modals/integrador-crm-modal/integrador-crm-modal.component';
import { ClientesModalComponent } from '../../../modals/clientes-modal/clientes-modal.component';
import { Cliente } from '../../../models/cliente';
import { ClienteService } from '../../../services/cliente.service';
import { CRMHierarquiaUsuario } from '../../../models/crmhierarquia-usuario';
import { CRMHierarquiaUsuarioService } from '../../../services/crmhierarquia-usuario.service';
import { UsuarioLogado } from '../../../models/usuario-logado';
import { FuncionarioService } from 'src/app/services/funcionario.service';

declare const $: any;

@Component({
  selector: 'app-cadastrar-oportunidade',
  templateUrl: './cadastrar-oportunidade.component.html',
  styleUrls: ['./cadastrar-oportunidade.component.scss']
})
export class CadastrarOportunidadeComponent implements OnInit {
  // variáveis
  usuarioLogado: UsuarioLogado;
  idUsuarioAtual = 0;
  perfil: PerfilDoUsuario;
  idVendedor: any;
  vendedor: any;
  vendedores: CRMHierarquiaUsuario[] = [];

  idCRMOportunidade = '';
  oportunidade = new CRMOportunidade();
  editando = false;
  carregando = true;
  public MASKS = MASKS;
  editavel = true;
  padrao = false;

  canaisDeVenda: CRMCanalVenda[] = [];
  usuarios: CRMHierarquiaUsuario[] = [];
  crm: CRM;
  etapas: CRMEtapaFunil[] = [];

  tags: CRMTag[] = [];
  tagsDaOportunidade = [];

  estaNaHierarquia = false;
  AtributoMascaras = CRMAtributoMascara;

  public config: PerfectScrollbarConfigInterface = {};
  administrador: boolean;
  tipo: number;

  constructor(
    private route: ActivatedRoute,
    private notificacaoService: NotificacaoService,
    private tagService: CrmtagService,
    private oportunidadeService: CrmoportunidadeService,
    private crmService: CrmService,
    private contatoService: CrmcontatoService,
    private router: Router,
    private canalDeVendaService: CrmcanalVendaService,
    private hierarquiaService: CRMHierarquiaUsuarioService,
    private globalService: GlobalService,
    private carregandoService: CarregandoService,
    private utilitarioService: UtilitarioService,
    private funcionarioService: FuncionarioService,
    public dialog: MatDialog,
    @Optional() public dialogRef: MatDialogRef<CadastrarOportunidadeComponent>,
    private fvatributoService: CrmatributoService,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit() {
    this.crm = this.data.crm;
    this.buscarVendedores();
    this.verificaExistenciaNaHierarquia();
  }

  buscarTags() {
    this.carregandoService.mostra('buscarTags');

    this.tagService.consultarTags().subscribe(
      (tags) => {
        this.tags = tags.filter(t => t.statusCadastro === StatusCadastroEnum.Ativo);

        this.carregandoService.esconde('buscarTags');
      },
      (erro) => {
        this.carregandoService.esconde('buscarTags');
        this.notificacaoService.erro(erro);
      }
    );
  }

  buscarAtributos() {
    this.carregandoService.mostra('buscarAtributos');

    this.fvatributoService.consultarPorIdOportunidade(0).subscribe((atributos) => {
      this.oportunidade.atributos = atributos;

      this.carregandoService.esconde('buscarAtributos');
    },
    (erro) => {
      this.carregandoService.esconde('buscarAtributos');
      this.notificacaoService.erro(erro);
    }
    );
  }

  buscarVendedores() {

    if (this.administrador || this.tipo !== 0) {

      this.funcionarioService.consultarFuncionariosPedido().subscribe(resp => {
        this.vendedores = resp.map(p => ({ idFuncion: Number(p.idFuncion), nome: p.nome }));
        //if (this.vendedores.length > 1) {
        //  this.vendedores.unshift({ idFuncion: 0, nome: 'Todos' });
        //}
      }, (erro) => {
        this.notificacaoService.erro(erro);
      });
    }
    else {

      this.hierarquiaService.consultarHierarquiaDoUsuarioLista().subscribe(resp => {
        this.vendedores = resp;

        this.vendedores.splice(this.vendedores.
          indexOf(this.vendedores.find(p => p.idFuncion === Number(this.usuarioLogado.id))), 1);

        //if (this.vendedores.length > 0) {
        //  const todos = new CRMHierarquiaUsuario();
        //  todos.idFuncion = 0;
        //  todos.nome = 'Todos';
        //  this.vendedores.unshift(todos);
        //}

        const somenteEu = new CRMHierarquiaUsuario();
        somenteEu.idFuncion = -1;
        somenteEu.nome = 'Somente eu';
        this.vendedores.unshift(somenteEu);

      }, (erro) => {
        this.notificacaoService.erro(erro);
      });
    }
  }

  verificaExistenciaNaHierarquia() {
    this.carregandoService.mostra('verificaHierarquia');

    this.hierarquiaService.usuarioDentroDaHierarquia().subscribe(resp => {

      this.carregandoService.esconde('verificaHierarquia');
      this.carregando = false;

      if (!resp) {
        swal({
          title: 'Atenção!!!',
          text: 'Você não é membro de nenhum time!!!',
          buttonsStyling: false,
          confirmButtonClass: 'btn btn-warning',
          type: 'warning'
        }).then(() => {
          this.router.navigate(['/crm/oportunidades']);
        });
      } else {
        this.estaNaHierarquia = true;
        this.buscarCanaisDeVenda();
        this.buscarUsuarios();
        this.buscarTags();

        this.oportunidade = new CRMOportunidade();
        this.oportunidade.idCRM = this.crm.id;
        this.oportunidade.dtExpectativa = new Date();
        this.atualizaDadosFVOportunidade();
      }
    }, (erro) => {
      this.carregandoService.esconde('verificaHierarquia');
      this.notificacaoService.erro(erro);
    });
  }

  ngAfterViewInit(): void {
    this.utilitarioService.rodaScriptTabEnter();
  }

  buscarCRMOportunidade() {
    this.carregandoService.mostra('buscaFVOportunidade');

    this.oportunidadeService.consultarPorIdOportunidade(this.idCRMOportunidade).subscribe(resp => {
      this.oportunidade = resp;
      this.atualizaDadosFVOportunidade();
    }, (erro) => {
      this.carregandoService.esconde('buscaFVOportunidade');
      this.notificacaoService.erro(erro);
    });
  }

  buscarCanaisDeVenda() {
    this.carregandoService.mostra('buscaCanaisDeVenda');

    this.canalDeVendaService.consultarCanaisVenda().subscribe(resp => {
      this.canaisDeVenda = resp.filter(c => c.statusCadastro === StatusCadastroEnum.Ativo);
      this.carregandoService.esconde('buscaCanaisDeVenda');
    }, (erro) => {
      this.carregandoService.esconde('buscaCanaisDeVenda');
      this.notificacaoService.erro(erro);
    });
  }

  buscarUsuarios() {
    this.carregandoService.mostra('buscaUsuarios');

    this.hierarquiaService.consultarHierarquiaDoUsuarioLista().subscribe(resp => {
      this.usuarios = resp;
      if (this.usuarios && this.usuarios.length > 0) {
        this.oportunidade.idUsuario = this.usuarios[0].idFuncion;
      }
      this.carregandoService.esconde('buscaUsuarios');
    }, (erro) => {
      this.carregandoService.esconde('buscaUsuarios');
      this.notificacaoService.erro(erro);
    });
  }

  buscarEtapasDoCRM() {
    if (!this.oportunidade.idCRM) {
      this.etapas = [];
      return;
    }

    this.carregandoService.mostra('buscaEtapas');

    this.crmService.consultarEtapasDoCRM(this.oportunidade.idCRM).subscribe(resp => {
      this.etapas = resp;
      this.carregandoService.esconde('buscaEtapas');
    }, (erro) => {
      this.carregandoService.esconde('buscaEtapas');
      this.notificacaoService.erro(erro);
    });
  }

  atualizaDadosFVOportunidade() {
    this.buscarEtapasDoCRM();
    this.buscarAtributos();

    this.carregando = false;

    this.carregandoService.esconde('buscaFVOportunidade');
  }

  salvar() {
    this.carregandoService.mostra('salvaFVOportunidade');

    if (this.tagsDaOportunidade && this.tagsDaOportunidade !== null && this.tagsDaOportunidade.length > 0) {
      this.oportunidade.tags = this.tags.filter(p => this.tagsDaOportunidade.some(t => t === p.id));
    } else {
      this.oportunidade.tags = [];
    }

    const oportunidadeParaSalvar = Object.assign({}, this.oportunidade);

    try {
      oportunidadeParaSalvar.valorEstimado = Number(oportunidadeParaSalvar.valorEstimado);
      if (oportunidadeParaSalvar.potencia !== undefined && oportunidadeParaSalvar.potencia !== null) {
        oportunidadeParaSalvar.potencia = Number(oportunidadeParaSalvar.potencia);
      }
      if (oportunidadeParaSalvar.consumo !== undefined && oportunidadeParaSalvar.consumo !== null) {
        oportunidadeParaSalvar.consumo = Number(oportunidadeParaSalvar.consumo);
      }

      // É necessário converter o valor dos atributos para string
      oportunidadeParaSalvar.atributos.forEach(atributo => {
        if (atributo.valor) {
          if (atributo.mascara === CRMAtributoMascara.MaskNumber) {
            atributo.valor = this.utilitarioService.formataNumeroParaSalvar(atributo.valor.toString());
          } else if (atributo.mascara === CRMAtributoMascara.MaskDate) {
            const atributoData = new Date(atributo.valor);
            atributo.valor = atributoData.toISOString();
          }
        }
      });

      this.oportunidadeService.salvar(oportunidadeParaSalvar).subscribe((novoId) => {
        this.notificacaoService.sucesso('Card salvo com sucesso!!!');
        this.router.navigate(['/crm/oportunidades/editar', novoId]).then(() => {
          this.carregandoService.esconde('salvaFVOportunidade');
          this.dialogRef.close();
        });

      }, (erro) => {
        this.carregandoService.esconde('salvaFVOportunidade');
        this.notificacaoService.erro(erro);
      });
    } catch (erro) {
      this.carregandoService.esconde('salvaFVOportunidade');
      this.notificacaoService.erro(erro);
    }
  }

  validaSalvar() {
    return this.oportunidade.idEtapa;
  }

  pesquisarCliente() {
    const dialogRef = this.dialog.open(ClientesModalComponent, {
      width: ($('body').width()).toString() + 'px',
      data: {
        gi: 1,
        esconderBotao: true
      },
      panelClass: 'modal-card'
    });

    dialogRef.afterClosed().subscribe((result: { cliente: Cliente, vendedor: any, limDesc: any }) => {
      if (result) {
        this.selecionaCliente(result.cliente, result.vendedor, result.limDesc, true);
      }
    }
    );
  }

  selecionaCliente(cliente: Cliente, vendedor: any, limDesc: any, veioDoModal: boolean) {
    this.oportunidade.cliente = cliente;
    this.oportunidade.idCliente = cliente.id;

    this.vendedor = vendedor;
  }

  pesquisarContato() {
    // const dialogRef = this.dialog.open(IntegradorCrmModalComponent, {
    //   width: ($('body').width()).toString() + 'px',
    //   data: {},
    //   panelClass: 'modal-card'
    // });

    // dialogRef.afterClosed().subscribe((result: Cliente) => {
    //   if (result) {
    //     this.carregandoService.mostra('buscarContato');

    //     this.contatoService.consultarPorIdContato(result.id).subscribe(
    //       (contato) => {
    //         this.oportunidade.contato = contato;
    //         this.oportunidade.idContato = contato.id;

    //         this.carregandoService.esconde('buscarContato');
    //       },
    //       (erro) => {
    //         this.carregandoService.esconde('buscarContato');
    //         this.notificacaoService.erro(erro);
    //       }
    //     );
    //   }
    // });
  }

  fechar() {
    this.dialogRef.close();
  }

  ngOnDestroy(): void {}
}
